import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainLayoutRoutingModule } from './main-layout-routing.module';
import { RouterModule } from '@angular/router';
import { HighchartsChartModule } from 'highcharts-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { MenuModule } from 'primeng/menu';
import { MegaMenuModule } from 'primeng/megamenu';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { DialogService, DynamicDialogConfig, DynamicDialogModule } from 'primeng/dynamicdialog';
import { BadgeModule } from 'primeng/badge';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { AccordionModule } from 'primeng/accordion';
import { FileUploadModule } from 'primeng/fileupload';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { FieldsetModule } from 'primeng/fieldset';
import { TooltipModule } from 'primeng/tooltip';
import { PanelModule } from 'primeng/panel';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { PaginatorModule } from 'primeng/paginator';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TabMenuModule } from 'primeng/tabmenu';
import { GlobalAttachmentsComponent } from '../directives/global-attachments/global-attachments.component';
import { DepartmentmodalComponent } from '../directives/departmentmodal/departmentmodal.component';
import { LocationmodalComponent } from '../directives/locationmodal/locationmodal.component';
import { EntitymodalComponent } from '../directives/entitymodal/entitymodal.component';
import { VerticalmodalComponent } from '../directives/verticalmodal/verticalmodal.component';
import { SidebarModule } from 'primeng/sidebar';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { UsermodalComponent } from '../directives/usermodal/usermodal.component';
import { UploadexcelformatComponent } from '../directives/uploadexcelformat/uploadexcelformat.component';
import { ExceldownloadComponent } from '../directives/exceldownload/exceldownload.component';
import { BulkexceluploadComponent } from '../directives/bulkexcelupload/bulkexcelupload.component';
import { HeaderComponent } from './header/header.component';
import { OrgsetupComponent } from './orgsetup/orgsetup.component';
import { DepartmentComponent } from './department/department.component';
import { LocationComponent } from './location/location.component';
import { EntityComponent } from './entity/entity.component';
import { VerticalComponent } from './vertical/vertical.component';
import { UsersComponent } from './users/users.component';
import { MainLayoutComponent } from './main-layout.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CitymodalComponent } from '../directives/citymodal/citymodal.component';
import { HubmodalComponent } from '../directives/hubmodal/hubmodal.component';
import { RegionmodalComponent } from '../directives/regionmodal/regionmodal.component';
import { CityComponent } from './city/city.component';
import { RegionComponent } from './region/region.component';
import { HubComponent } from './hub/hub.component';
import { ApplicationconfigurationComponent } from './applicationconfiguration/applicationconfiguration.component';
import { ApplicationconfigurationmodalComponent } from '../directives/applicationconfigurationmodal/applicationconfigurationmodal.component';
import { MenubarModule } from 'primeng/menubar';
import { CountryComponent } from './country/country.component';
import { CountrymodalComponent } from '../directives/countrymodal/countrymodal.component';
import { UseraccessmappingComponent } from './useraccessmapping/useraccessmapping.component';
import { UsersubmenuComponent } from './header/usersubmenu/usersubmenu.component';
import { EntitytypeComponent } from './entitytype/entitytype.component';
import { SubverticalComponent } from './subvertical/subvertical.component';
import { SubdepartmentComponent } from './subdepartment/subdepartment.component';
import { EntitytypemodalComponent } from '../directives/entitytypemodal/entitytypemodal.component';
import { SubdepartmentmodalComponent } from '../directives/subdepartmentmodal/subdepartmentmodal.component';
import { SubverticalmodalComponent } from '../directives/subverticalmodal/subverticalmodal.component';
import { StateComponent } from './state/state.component';
import { StatemodalComponent } from '../directives/statemodal/statemodal.component';
import { LocationtypeComponent } from './locationtype/locationtype.component';
import { LocationtypemodalComponent } from '../directives/locationtypemodal/locationtypemodal.component';
import { CurrencyComponent } from './currency/currency.component';
import { CurrencymodalComponent } from '../directives/currencymodal/currencymodal.component';
import { OrganisationComponent } from './organisation/organisation.component';
import { OrganisationmodalComponent } from '../directives/organisationmodal/organisationmodal.component';
import { OrgtrainingmodalComponent } from '../directives/orgtrainingmodal/orgtrainingmodal.component';
import { OrganisationbusinessusermodalComponent } from '../directives/organisationbusinessusermodal/organisationbusinessusermodal.component';
import { SupportverificationcationmodalComponent } from '../directives/supportverificationcationmodal/supportverificationcationmodal.component';
import { LoginsecuritymodalComponent } from '../directives/loginsecuritymodal/loginsecuritymodal.component';
import { CommonmastersauditlogComponent } from './commonmastersauditlog/commonmastersauditlog.component';
import { ClientgroupComponent } from './clientgroup/clientgroup.component';
import { ClientgroupmodalComponent } from '../directives/clientgroupmodal/clientgroupmodal.component';
import { SupportadminmenuComponent } from './header/supportadminmenu/supportadminmenu.component';
import { userLogComponent } from './userLog/userLog.component';
import { SchedularLogComponent } from './schedularlog/schedularLog.component';
import { SchedulelogfiltersComponent } from '../directives/filters/schedulelogfilters/schedulelogfilters.component';
import { UserlogfiltersComponent } from '../directives/filters/userlogfilters/userlogfilters.component';
import { FullbackupComponent } from '../directives/fullbackup/fullbackup.component';

import { PagehelpmodalComponent } from '../directives/pagehelpmodal/pagehelpmodal.component';
import { CaptchaComponent } from '../directives/captcha/captcha.component';
import { OtpInputComponent } from '../directives/otp-input/otp-input.component';
import { LegalmodifyentitymodalComponent } from '../directives/legalmodifyentitymodal/legalmodifyentitymodal.component';
import { FinancialyearComponent } from './financialyear/financialyear.component';
import { FinancialyearmodalComponent } from '../directives/financialyearmodal/financialyearmodal.component';
import { MycredentialsComponent } from './mycredentials/mycredentials.component';
import { MycredentialmodalComponent } from '../directives/mycredentialmodal/mycredentialmodal.component';
import { CommondashboardComponent } from './commondashboard/commondashboard.component';
import { ColumnindexmodalComponent } from '../directives/columnindexmodal/columnindexmodal.component';
import { OrganisationcrmusermodalComponent } from '../directives/organisationcrmusermodal/organisationcrmusermodal.component';
import { UnlicenseduserComponent } from './unlicenseduser/unlicenseduser.component';
import { UnlicensedusermodalComponent } from '../directives/unlicensedusermodal/unlicensedusermodal.component';
import { MyconfigurationComponent } from './myconfiguration/myconfiguration.component';
import { LoginpagemessagesComponent } from './loginpagemessages/loginpagemessages.component';
import { LoginpagemessagesmodalComponent } from '../directives/loginpagemessagesmodal/loginpagemessagesmodal.component';
import { OrganisationstatisticsComponent } from './organisationstatistics/organisationstatistics.component';
import { ClientusagereportComponent } from './clientusagereport/clientusagereport.component';
import { SignatorydetailsComponent } from './signatorydetails/signatorydetails.component';
import { SignatorymodalComponent } from '../directives/signatorymodal/signatorymodal.component';
import { EsignhomeComponent } from './esignhome/esignhome.component';
import { EsignhomemodalComponent } from '../directives/esignhomemodal/esignhomemodal.component';
import { RemoveorganisationComponent } from './removeorganisation/removeorganisation.component';
import { UserhelpComponent } from './userhelp/userhelp.component';
import { EditorModule } from 'primeng/editor';
import { InvalidfileextensionsComponent } from './invalidfileextensions/invalidfileextensions.component';
import { InvalidfileextensionsmodalComponent } from '../directives/invalidfileextensionsmodal/invalidfileextensionsmodal.component';
import { HelpmasterComponent } from './helpmaster/helpmaster.component';
import { HelpmastermodalComponent } from '../directives/helpmastermodal/helpmastermodal.component';
import { VersionupdateComponent } from './versionupdate/versionupdate.component';
import { VersionupdatefiltersComponent } from '../directives/filters/versionupdatefilters/versionupdatefilters.component';
import { VersionupdatemodalComponent } from '../directives/versionupdatemodal/versionupdatemodal.component';
import { ApplicationlogsComponent } from './applicationlogs/applicationlogs.component';
import { ErrorlogmodalComponent } from '../directives/errorlogmodal/errorlogmodal.component';
@NgModule({
  declarations: [
    MainLayoutComponent, GlobalAttachmentsComponent,
    HeaderComponent, BulkexceluploadComponent,
    OrgsetupComponent, VerticalmodalComponent,
    DepartmentComponent, DepartmentmodalComponent,
    LocationComponent, LocationmodalComponent, EntityComponent,
    VerticalComponent, UsersComponent, UsermodalComponent,
    UploadexcelformatComponent, ExceldownloadComponent,
    EntitymodalComponent, CitymodalComponent, HubmodalComponent, RegionmodalComponent, CityComponent, RegionComponent, 
    HubComponent, ApplicationconfigurationmodalComponent, ApplicationconfigurationComponent, CountryComponent,
    CountrymodalComponent, OrgtrainingmodalComponent, OtpInputComponent,
    UseraccessmappingComponent, OrganisationbusinessusermodalComponent,
    UsersubmenuComponent, EntityComponent, EntitytypeComponent, SubverticalComponent, SubdepartmentComponent,
    EntitytypemodalComponent, SubdepartmentmodalComponent, SubverticalmodalComponent, StateComponent, StatemodalComponent, 
    LocationtypeComponent, LocationtypemodalComponent,
    CurrencyComponent, CurrencymodalComponent, OrganisationComponent, OrganisationmodalComponent, 
    SupportverificationcationmodalComponent, LoginsecuritymodalComponent, SupportadminmenuComponent,
    userLogComponent, SchedularLogComponent, UserlogfiltersComponent, SchedulelogfiltersComponent, FullbackupComponent, 
    CaptchaComponent, SupportverificationcationmodalComponent, LoginsecuritymodalComponent, CommonmastersauditlogComponent, 
    ClientgroupComponent, ClientgroupmodalComponent, SupportadminmenuComponent, PagehelpmodalComponent, LegalmodifyentitymodalComponent, 
    FinancialyearComponent,FinancialyearmodalComponent, MycredentialsComponent, MycredentialmodalComponent, CommondashboardComponent, 
    ColumnindexmodalComponent,OrganisationcrmusermodalComponent, UnlicenseduserComponent,UnlicensedusermodalComponent,
    MyconfigurationComponent, LoginpagemessagesComponent,LoginpagemessagesmodalComponent, OrganisationstatisticsComponent, ClientusagereportComponent, 
    SignatorydetailsComponent,SignatorymodalComponent, EsignhomeComponent,EsignhomemodalComponent, RemoveorganisationComponent, UserhelpComponent, InvalidfileextensionsComponent,
    InvalidfileextensionsmodalComponent,HelpmasterComponent,HelpmastermodalComponent, VersionupdateComponent,VersionupdatefiltersComponent,VersionupdatemodalComponent,ApplicationlogsComponent,
    ErrorlogmodalComponent
  ],
  imports: [
    CommonModule,
    MainLayoutRoutingModule,
    RouterModule, BreadcrumbModule, MenubarModule,
    HighchartsChartModule, NgSelectModule, FormsModule,
    ReactiveFormsModule, ButtonModule, TabViewModule, TabMenuModule,
    CardModule, DropdownModule, TableModule, MenuModule, InputTextModule, MultiSelectModule, DynamicDialogModule,
    BadgeModule, CalendarModule, DialogModule, AccordionModule, FileUploadModule, OverlayPanelModule, FieldsetModule, PanelModule, TooltipModule,
    PaginatorModule, SelectButtonModule, SidebarModule, InputTextareaModule, MegaMenuModule,EditorModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),

  ],
  providers: [DynamicDialogConfig, DialogService]
})
export class MainLayoutModule { }
